import  { useEffect } from 'react';
import { Navigate, useLocation} from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import { toast } from 'sonner';
import Loading from '../loading-app/Loading';

function Login() {
  const { authState, oktaAuth } = useOktaAuth();
  const location = useLocation();
  const isCallbackUrl = window.location.pathname.includes('/login/callback');

  useEffect(() => {
    if (!authState?.isAuthenticated) {
      oktaAuth.signInWithRedirect();
    }
  }, [authState, oktaAuth]);

  // Show toast if redirected with showAuthError flag
  useEffect(() => {
    if (location.state && location.state.showAuthError) {
        toast('You are not authorized to access this application.',
            {
        duration: 5000,
        style: { background: '#ef4444', color: 'white' }
      });
    }
  }, [location.state]);

  
  // If we're on callback URL, show loading instead of navigating
  if (isCallbackUrl) {
    return <Loading />;
  }

  // Only navigate when auth state is definitively known
  if (authState) {
    return authState.isAuthenticated ? 
      <Navigate to="/" replace /> : 
      <Navigate to="/home" replace />;
  }

  // While waiting for auth state, show loading
  return <Loading />;
   
}

export default Login;